import React, { useState } from 'react';
import { useLanguage } from '../context/LanguageContext';

// ── Data ──────────────────────────────────────────────────────────────────────
const niyamList = [
  {
    id: 1,
    label: 'महाराष्ट्र जिल्हा ग्राम विकास निधी (सुधारणा) नियम, 2019.',
    englishLabel: 'Maharashtra Zilla Gram Vikas Nidhi (Amendment) Rules, 2019.',
    lastUpdated: 'शुक्रवार, 15 सप्टेंबर 2023, 11:06:54 AM',
    englishLastUpdated: 'Friday, 15 September 2023, 11:06:54 AM',
    pdfLink: '#',
    linkText: 'महाराष्ट्र जिल्हा ग्राम विकास निधी (सुधारणा) नियम, 2019.',
    englishLinkText: 'Maharashtra Zilla Gram Vikas Nidhi (Amendment) Rules, 2019.',
  },
  {
    id: 2,
    label: 'महाराष्ट्र नागरी सेवा (सुधारित वेतन) नियम, 2019 - अधिसूचना- 30 जानेवारी 2019',
    englishLabel: 'Maharashtra Civil Services (Revised Pay) Rules, 2019 - Notification - 30 January 2019',
    lastUpdated: 'बुधवार, 30 जानेवारी 2019, 09:00:00 AM',
    englishLastUpdated: 'Wednesday, 30 January 2019, 09:00:00 AM',
    pdfLink: '#',
    linkText: 'महाराष्ट्र नागरी सेवा (सुधारित वेतन) नियम, 2019 - अधिसूचना- 30 जानेवारी 2019.',
    englishLinkText: 'Maharashtra Civil Services (Revised Pay) Rules, 2019 - Notification - 30 January 2019.',
  },
  {
    id: 3,
    label: 'विभागीय चौकशी नियम पुस्तिका- 1991',
    englishLabel: 'Departmental Enquiry Rule Book - 1991',
    lastUpdated: 'सोमवार, 1 जानेवारी 1991, 10:00:00 AM',
    englishLastUpdated: 'Monday, 1 January 1991, 10:00:00 AM',
    pdfLink: '#',
    linkText: 'विभागीय चौकशी नियम पुस्तिका- 1991.',
    englishLinkText: 'Departmental Enquiry Rule Book - 1991.',
  },
  {
    id: 4,
    label: 'महाराष्ट्र नागरी सेवा (शिस्त व अपील) नियम 1979',
    englishLabel: 'Maharashtra Civil Services (Discipline and Appeal) Rules 1979',
    lastUpdated: 'गुरुवार, 1 मार्च 1979, 08:00:00 AM',
    englishLastUpdated: 'Thursday, 1 March 1979, 08:00:00 AM',
    pdfLink: '#',
    linkText: 'महाराष्ट्र नागरी सेवा (शिस्त व अपील) नियम 1979.',
    englishLinkText: 'Maharashtra Civil Services (Discipline and Appeal) Rules 1979.',
  },
  {
    id: 5,
    label: 'महाराष्ट्र नागरी सेवा (वर्तणूक) नियम 1979',
    englishLabel: 'Maharashtra Civil Services (Conduct) Rules 1979',
    lastUpdated: 'शुक्रवार, 1 जून 1979, 08:00:00 AM',
    englishLastUpdated: 'Friday, 1 June 1979, 08:00:00 AM',
    pdfLink: '#',
    linkText: 'महाराष्ट्र नागरी सेवा (वर्तणूक) नियम 1979.',
    englishLinkText: 'Maharashtra Civil Services (Conduct) Rules 1979.',
  },
  {
    id: 6,
    label: 'महाराष्ट्र ग्रामपंचायत (नोकरीच्या शर्ती) नियम 1959',
    englishLabel: 'Maharashtra Gram Panchayat (Conditions of Service) Rules 1959',
    lastUpdated: 'सोमवार, 5 जुलै 2021, 04:00:00 PM',
    englishLastUpdated: 'Monday, 5 July 2021, 04:00:00 PM',
    pdfLink: '#',
    linkText: 'महाराष्ट्र ग्रामपंचायत (नोकरीच्या शर्ती) नियम 1959.',
    englishLinkText: 'Maharashtra Gram Panchayat (Conditions of Service) Rules 1959.',
  },
  {
    id: 7,
    label: 'महाराष्ट्र ग्राम पंचायत निवडणूक नियम 1959',
    englishLabel: 'Maharashtra Gram Panchayat Election Rules 1959',
    lastUpdated: 'बुधवार, 12 ऑगस्ट 2020, 02:30:00 PM',
    englishLastUpdated: 'Wednesday, 12 August 2020, 02:30:00 PM',
    pdfLink: '#',
    linkText: 'महाराष्ट्र ग्राम पंचायत निवडणूक नियम 1959.',
    englishLinkText: 'Maharashtra Gram Panchayat Election Rules 1959.',
  },
  {
    id: 8,
    label: 'महाराष्ट्र जमीन महसूल नियम 1966',
    englishLabel: 'Maharashtra Land Revenue Rules 1966',
    lastUpdated: 'मंगळवार, 20 ऑक्टोबर 2020, 11:15:00 AM',
    englishLastUpdated: 'Tuesday, 20 October 2020, 11:15:00 AM',
    pdfLink: '#',
    linkText: 'महाराष्ट्र जमीन महसूल नियम 1966.',
    englishLinkText: 'Maharashtra Land Revenue Rules 1966.',
  },
  {
    id: 9,
    label: 'महाराष्ट्र ग्रामपंचायत लेखा नियम 1965',
    englishLabel: 'Maharashtra Gram Panchayat Account Rules 1965',
    lastUpdated: 'गुरुवार, 8 एप्रिल 2021, 10:00:00 AM',
    englishLastUpdated: 'Thursday, 8 April 2021, 10:00:00 AM',
    pdfLink: '#',
    linkText: 'महाराष्ट्र ग्रामपंचायत लेखा नियम 1965.',
    englishLinkText: 'Maharashtra Gram Panchayat Account Rules 1965.',
  },
  {
    id: 10,
    label: 'महाराष्ट्र नागरी सेवा (निवृत्ती वेतन) नियम 1982',
    englishLabel: 'Maharashtra Civil Services (Pension) Rules 1982',
    lastUpdated: 'शुक्रवार, 14 मे 2021, 03:00:00 PM',
    englishLastUpdated: 'Friday, 14 May 2021, 03:00:00 PM',
    pdfLink: '#',
    linkText: 'महाराष्ट्र नागरी सेवा (निवृत्ती वेतन) नियम 1982.',
    englishLinkText: 'Maharashtra Civil Services (Pension) Rules 1982.',
  },
];

const ITEMS_PER_PAGE = 5;

// ── PDF Preview Placeholder ────────────────────────────────────────────────────
const PdfPlaceholder = () => (
  <div
    className="w-full rounded border border-gray-200 flex flex-col items-center justify-center"
    style={{ minHeight: '420px', backgroundColor: '#f0f0f0' }}
  >
    {/* Document Icon */}
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className="mb-3"
      width="56"
      height="56"
      viewBox="0 0 24 24"
      fill="none"
      stroke="#bbb"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
      <polyline points="14 2 14 8 20 8" />
      <line x1="10" y1="13" x2="10" y2="13" />
      <line x1="8" y1="17" x2="16" y2="17" />
      <line x1="8" y1="13" x2="16" y2="13" />
    </svg>
    <p className="text-sm text-gray-400">PDF उपलब्ध नाही / Preview लोड होत नाही</p>
  </div>
);

// ── Main Component ─────────────────────────────────────────────────────────────
const Niyam = () => {
  const { language } = useLanguage();
  const [selectedNiyam, setSelectedNiyam] = useState(niyamList[0]);
  const [searchQuery, setSearchQuery] = useState('');
  const [currentPage, setCurrentPage] = useState(1);

  // Filter list by search
  const filtered = niyamList.filter((n) => {
    const labelToSearch = language === 'marathi' ? n.label : n.englishLabel;
    return labelToSearch.toLowerCase().includes(searchQuery.toLowerCase());
  });

  const totalPages = Math.ceil(filtered.length / ITEMS_PER_PAGE);
  const paginated = filtered.slice(
    (currentPage - 1) * ITEMS_PER_PAGE,
    currentPage * ITEMS_PER_PAGE
  );

  const handleSearch = (e) => {
    setSearchQuery(e.target.value);
    setCurrentPage(1);
  };

  // Translations
  const t = {
    title: language === 'marathi' ? 'नियम' : 'Rules',
    search: language === 'marathi' ? 'Search:' : 'Search:',
    noNiyam: language === 'marathi' ? 'कोणतेही नियम सापडले नाही' : 'No rules found',
    selectNiyam: language === 'marathi' ? 'डाव्या बाजूने नियम निवडा' : 'Select a rule from the left',
    lastUpdated: language === 'marathi' ? 'Last Updated: ' : 'Last Updated: ',
    prev: language === 'marathi' ? 'Previous' : 'Previous',
    next: language === 'marathi' ? 'Next' : 'Next'
  };

  return (
    <div className="min-h-screen bg-gray-100">

      {/* ── Page Content ── */}
      <div className="max-w-7xl mx-auto px-4 py-6">
        <div className="flex gap-4 items-start">

          {/* ── Left Sidebar ── */}
          <div className="w-72 flex-shrink-0">

            {/* Sidebar Header */}
            <div
              className="flex items-center gap-2 px-3 py-2.5 rounded-t-md font-semibold text-sm text-gray-800"
              style={{ backgroundColor: '#e8e8e8', borderLeft: '4px solid #f26b6b' }}
            >
              <span>📢</span>
              <span>{t.title}</span>
            </div>

            {/* Search Box */}
            <div className="bg-white border border-gray-200 px-3 py-2">
              <div className="flex items-center gap-2">
                <label className="text-sm text-gray-600 whitespace-nowrap">{t.search}</label>
                <input
                  type="text"
                  value={searchQuery}
                  onChange={handleSearch}
                  className="flex-1 border border-gray-300 rounded px-2 py-1 text-sm focus:outline-none focus:border-blue-400"
                />
              </div>
            </div>

            {/* Niyam List */}
            <div className="bg-white border border-gray-200 border-t-0 flex flex-col gap-1 p-2">
              {paginated.length === 0 ? (
                <p className="text-sm text-gray-500 text-center py-4">{t.noNiyam}</p>
              ) : (
                paginated.map((niyam) => {
                  const niyamLabel = language === 'marathi' ? niyam.label : niyam.englishLabel;
                  return (
                    <button
                      key={niyam.id}
                      onClick={() => setSelectedNiyam(niyam)}
                      className="w-full text-left text-sm font-medium px-3 py-2.5 rounded transition-all duration-150 text-white hover:opacity-90"
                      style={{
                        backgroundColor:
                          selectedNiyam?.id === niyam.id ? '#f59e0b' : '#06b6d4',
                      }}
                    >
                      {niyamLabel}
                    </button>
                  );
                })
              )}
            </div>

            {/* Pagination */}
            {totalPages > 1 && (
              <div className="bg-white border border-gray-200 border-t-0 px-2 py-2 flex flex-wrap items-center gap-1">
                <button
                  onClick={() => setCurrentPage((p) => Math.max(1, p - 1))}
                  disabled={currentPage === 1}
                  className="px-2 py-1 text-xs border border-gray-300 rounded hover:bg-gray-50 disabled:opacity-40"
                >
                  {t.prev}
                </button>
                {Array.from({ length: totalPages }, (_, i) => i + 1).map((page) => (
                  <button
                    key={page}
                    onClick={() => setCurrentPage(page)}
                    className="w-7 h-7 text-xs rounded border transition-colors"
                    style={
                      currentPage === page
                        ? { backgroundColor: '#f26b6b', borderColor: '#f26b6b', color: 'white' }
                        : { borderColor: '#d1d5db' }
                    }
                  >
                    {page}
                  </button>
                ))}
                <button
                  onClick={() => setCurrentPage((p) => Math.min(totalPages, p + 1))}
                  disabled={currentPage === totalPages}
                  className="px-2 py-1 text-xs border border-gray-300 rounded hover:bg-gray-50 disabled:opacity-40"
                >
                  {t.next}
                </button>
              </div>
            )}
          </div>

          {/* ── Right Content Panel ── */}
          <div className="flex-1 bg-white border border-gray-200 rounded-md shadow-sm">
            {selectedNiyam ? (
              <div className="p-5">

                {/* Title */}
                <h2
                  className="text-xl font-bold text-gray-800 border-b-2 pb-2 mb-1"
                  style={{ borderColor: '#f26b6b' }}
                >
                  {language === 'marathi' ? selectedNiyam.label : selectedNiyam.englishLabel}
                </h2>

                {/* Last Updated */}
                <p className="text-xs text-gray-500 text-right mb-4 italic">
                  {t.lastUpdated}{language === 'marathi' ? selectedNiyam.lastUpdated : selectedNiyam.englishLastUpdated}
                </p>

                {/* PDF Link */}
                <p className="text-sm mb-3">
                  <span className="text-gray-500 mr-1">-</span>
                  <a
                    href={selectedNiyam.pdfLink}
                    className="hover:underline transition-colors"
                    style={{ color: '#1a56db' }}
                    target="_blank"
                    rel="noreferrer"
                  >
                    {language === 'marathi' ? selectedNiyam.linkText : selectedNiyam.englishLinkText}
                  </a>
                </p>

                {/* Content Area — plain gray background matching image */}
                <div
                  className="w-full rounded border border-gray-200 mt-2"
                  style={{ minHeight: '380px', backgroundColor: '#f0f0f0' }}
                />

              </div>
            ) : (
              <div className="flex items-center justify-center h-64 text-gray-400">
                <p>{t.selectNiyam}</p>
              </div>
            )}
          </div>

        </div>
      </div>
    </div>
  );
};

export default Niyam;
